/// <amd-module name="Release/Commands/Dialogs/MovePipelineDialog" />
import * as React from "react";

import { Dialog } from "VSSUI/Dialog";
import { TextField } from "VSSUI/TextField";

import { format } from "VSS/Core/Util/String";
import { VssComponent, IVssComponentProperties, Components } from "VSS/Platform/Layout";
import * as Resources from "Release/Commands/Dialogs/Resources";

export interface IMovePipelineDialogProps extends IVssComponentProperties {
    initialPath: string;
    name: string;
    onPipelineMoved: (newFolderPath: string) => void;
    onClose: () => any;
}

interface IMovePipelineDialogState {
    path: string;
    pathErrorMessage: string;
}

export class MovePipelineDialog extends VssComponent<IMovePipelineDialogProps, IMovePipelineDialogState>{

    constructor(props: IMovePipelineDialogProps) {
        super(props);

        this.state = {
            path: this.props.initialPath,
            pathErrorMessage: ""
        };
    }

    public render(): React.ReactNode {
        return (
            <Dialog
                titleProps={{ text: Resources.MovePipelineDialogTitle }}
                onDismiss={this._onDialogClose}
                defaultActiveElement=".folder-name-input"
                escDismiss={true}
                calloutContentClassName="release-command-dialog"
                footerButtonProps={[
                    {
                        onClick: this._onDialogClose,
                        text: Resources.Cancel
                    },
                    {
                        onClick: this._onOkClick,
                        disabled: !!this.state.pathErrorMessage,
                        primary: true,
                        text: Resources.Ok
                    }
                ]}>
                <TextField
                    label={Resources.NameLabel}
                    value={this.props.name}
                    disabled={true} />
                <TextField
                    className="folder-text-field"
                    label={Resources.FolderPathTextboxLabel}
                    inputClassName={"folder-name-input"}
                    value={this.state.path}
                    onChange={this._onPathChanged} />
            </Dialog>
        );
    }

    private _onPathChanged = (event: React.ChangeEvent<HTMLInputElement>, newValue: string): void => {
        let errorMessage = "";
        if (!newValue) {
            errorMessage = Resources.CannotBeEmptyErrorMessage;
        }
        else {
            const invalidCharacters = "<>|:$@\"/?";
            for (let i = 0; i < invalidCharacters.length; i++) {
                if (newValue.indexOf(invalidCharacters[i]) !== -1) {
                    errorMessage = format(Resources.UnallowedCharactersErrorMessage, invalidCharacters);
                }
            }
        }

        this.setState({
            path: newValue,
            pathErrorMessage: errorMessage
        });
    }

    private _closeDialog() {
        if (!!this.props.onClose) {
            this.props.onClose();
        }
    }

    private _onDialogClose = (): void => {
        this._closeDialog();
    }

    private _onOkClick = (): void => {
        this.props.onClose();

        if (this.props.onPipelineMoved) {
            this.props.onPipelineMoved(this.state.path.trim());
        }
    }
}

Components.add("move-rd-dialog", MovePipelineDialog);